import { CircularProgress, Container, makeStyles } from "@material-ui/core";
import React from "react";

export const LoadMoreIndicator = () => {
  const classes = useStyles();
  return (
    <Container className={classes.component}>
      <CircularProgress />
    </Container>
  );
};
const useStyles = makeStyles({
  component: {
    width: "100%",
    textAlign: "center",
  },
});
